/**
 * Custom hook for fetching floor data
 */

import { useState, useEffect } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import apiFetch from '@wordpress/api-fetch';

const useFloorData = (selectedFloors) => {
    const [floorData, setFloorData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!selectedFloors || selectedFloors.length === 0) {
            setIsLoading(false);
            return;
        }

        const fetchFloorData = async () => {
            try {
                setIsLoading(true);
                const response = await apiFetch({ path: '/valve/v1/blocks/' });

                if (response && response.floors && response.floors.floor_posts) {
                    setFloorData(response.floors.floor_posts);
                } else {
                    setError(__('Invalid data format received from API'));
                }
            } catch (err) {
                console.error('API fetch error:', err);
                setError(__('Failed to fetch floor data:') + ' ' + err.message);
            } finally {
                setIsLoading(false);
            }
        };

        fetchFloorData();
    }, [selectedFloors]);

    return { floorData, isLoading, error };
};

export default useFloorData;
